import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'

const selectedLanguage = localStorage.getItem('language')?.toLowerCase()
const userLang = selectedLanguage || navigator.language || navigator.userLanguage
const defaultLocale = userLang.substring(0, 2)
i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    load: 'languageOnly',
    lng: defaultLocale,
    fallbackLng: 'es',
    backend: {
      loadPath: `${window.location.origin}/locales/{{lng}}.json`,
    },
  })

export default i18n

/**
 * Translate a basic message using i18
 *
 * @param {string} message - The message to display format CODE:param1:param2...
 * @param {string} [tag] - The tag to use for the translation
 * @returns string
 */
export function translateMessage(message, tag = null) {
  const messageTag = tag ?? 'alertmsg'
  const messageParams = message.split(':')
  const messageCode = messageParams.shift()

  const itemToTranslate = `${messageTag}.${messageCode}`.toLowerCase()

  let params = {}

  if (messageParams.length > 0) {
    messageParams.forEach((element, index) => {
      params[`${index + 1}`] = element
    })
  }

  const translation = i18n.t(itemToTranslate, params)
  return translation
}
